import React, { useContext, useEffect, useState } from 'react'
import AppRouter from './components/AppRouter'
import { BrowserRouter } from 'react-router-dom'
import NavBar from './components/NavBar';
import { observer } from 'mobx-react-lite';
import { Context } from './index';
import { check } from './http/userAPI';
import { Spinner } from 'react-bootstrap';
import MobNavBar from './components/MobNavBar';
import ChatApp from './components/chat/ChatApp';
import { requestNotificationPermission, initAudio } from './utils/notifications';




const App = observer(() =>{
  const {user, chat} = useContext(Context) 
  const [loading, setLoading] = useState(true)

  useEffect(() =>{
      check().then(data => {
        user.setUser(data)
        user.setIsAuth(true)
        // Запрашиваем разрешение на уведомления
      // requestNotificationPermission();
      }).finally(()=> setLoading(false))
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

   // Инициализация звука при первом клике пользователя
  useEffect(() => {
    const handleFirstClick = () => {
      initAudio();
      document.removeEventListener('click', handleFirstClick);
    };
    
    document.addEventListener('click', handleFirstClick);
    
    return () => {
      document.removeEventListener('click', handleFirstClick);
    };
  }, []);



   // Подключаем сокет и загружаем чаты, когда пользователь авторизован
  useEffect(() => {
    if (user.isAuth) {
      chat.connect(); // <-- Без параметра token
      chat.loadChats();
    } else {
      chat.disconnect();
    }
  }, [user.isAuth, chat])

    if (loading){
    return <Spinner animation={"grow"}/>
  }


  return (
    <BrowserRouter>
      <NavBar/>
      <MobNavBar/>
       <AppRouter/>
        <ChatApp />
    </BrowserRouter>
     
  );
});

export default App;
 